import React, { Component } from 'react'
import Main from '../Main'
import DrawerMenu from '../drawer/DrawerMenu'
import Footer from '../Footer'
import { Link, NavLink } from 'react-router-dom'
import Cookies from 'universal-cookie'
import TitleParticles from '../components/animations/TitleParticles'
import baileysbudhouse from '../assets/img/baileysbudhouse.png'
import { Button, ButtonGroup, Fade } from "@material-ui/core"
import WinteryDam from '../assets/img/winteryDam.webp'
import GP1 from '../assets/img/goldenpapaya/gp1.webp'
import GP2 from '../assets/img/goldenpapaya/gp2.webp'
import GP3 from '../assets/img/goldenpapaya/gp3.webp'
import GP4 from '../assets/img/goldenpapaya/gp4.webp'
import GP5 from '../assets/img/goldenpapaya/gp5.webp'
import GP6 from '../assets/img/goldenpapaya/gp6.webp'
import Background from '../assets/img/trenchtownBackground.png'
import Logosubscribe from '../components/CustomDialog/LogoSubscribe'
import InstagramIcon from '../assets/img/Instagram-Logo.png'
import Carousel from "react-slick"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Typography from '@material-ui/core/typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import AddIcon from '@material-ui/icons/Add'
import GridContainer from "../components/Grid/GridContainer"
import GridItem from "../components/Grid/GridItem"
import Card from "../components/Card/Card"
import goldenpapaya from "../assets/img/goldenpapaya.webp"

const useStyles = makeStyles(theme => ({
  item: {
    [theme.breakpoints.down('sm')]: {
      flexFlow:'column'
    },
    [theme.breakpoints.up('md')]: {
      flexFlow:'column'
    },
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
  },
  carousel: {
    [theme.breakpoints.down('sm')]: {
      height:'65vw',
      width:'90vw'
    },
    [theme.breakpoints.up('md')]: {
      height:'50vw',
      width:'90vw'
    },
    display:'flex',
    flexFlow:'column',
    justifyContent:'center',
    alignItems:'center'
  }
}));

export default function Trenchtown(props) {
  const classes = useStyles();
  const [autoplay, setAutoplay] = React.useState(false);
  const [itemId, setItemId] = React.useState("");
  const theme = useTheme();
  let media = useMediaQuery(theme.breakpoints.up('sm'));

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    centerMode:true,
    variableWidth:true
  };

  const carouselExample = () => {
    return (
      <div className={classes.item}>
        <GridContainer className={classes.carousel}>
          <GridItem >
            <Card carousel>
              <Carousel {...settings}>
                <div>
                  <img src={GP1} alt='...'
                    style={{height:'50vw'}}/>
                </div>
                <div>
                  <img src={GP2} alt='...'
                    style={{height:'50vw'}}/>
                </div>
                <div>
                <img src={GP3} alt='...'
                  style={{height:'50vw'}}/>
                </div>
                <div>
                  <img src={GP4} alt='...'
                    style={{height:'50vw'}}/>
                </div>
                <div>
                  <img src={GP5} alt='...'
                    style={{height:'50vw'}}/>
                </div>
                <div>
                  <img src={GP6} alt='...'
                    style={{height:'50vw'}}/>
                </div>
              </Carousel>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }

  return (

      <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignSelf:'center',
        alignItems:'center',backgroundImage: `url(${Background})`,backgroundPosition:'center'}}>

        <Typography style={{fontSize:'4vw',fontFamily:'Calibri',
          justifyContent:'center',alignSelf:'center',textAlign:'center',color:'#000000'}}>
          Bailey’s Buds is a social equity, family-owned microbusiness in Dracut. Our head grower,
          Gus Bailey, had grow-ops in Boston & Waltham until he got busted in 2011 & served 5 years in the slammer.
          When he was released from prison, the family pooled our resources to buy a dilapidated historic mill in Dracut & took it down to the studs to build out the grow.
        </Typography>
        <div style={{display:'flex',
          justifyContent:'center',alignItems:'center'}}>
          <iframe src="https://open.spotify.com/embed/playlist/0ldYKGbygs36J2ELP9e5K9?utm_source=generator" width="300" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media">
          </iframe>
        </div>
        <Typography style={{fontSize:'3.5vw',fontFamily:'Calibri',
          justifyContent:'center',alignSelf:'center',color:'#000000'}}>
          INDOOR ORGANIC NO-TILL LIVING SOIL
        </Typography>
        <Typography style={{fontSize:'3.5vw',fontFamily:'Calibri',
          justifyContent:'center',alignSelf:'center',color:'#000000'}}>
          EVERY BAILEY’S EIGHTH IS COMPLETELY HAND TRIMMED & ARTISTICALLY, DELIBERATELY & PAINSTAKINGLY HAND PACKED
        </Typography>

      </div>
  );
}
